import styled, { css } from 'styled-components'
import media from 'styled-media-query'
import cubes from 'assets/images/cubes.png'
import mcubes from 'assets/images/cubes-mobile.png'

export const Wrapper = styled.header`
  ${() => css`
    width: 100%;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  `}
`

export const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 846px;
  margin-bottom: 88px;

  ${media.lessThan('medium')`
    width: 100%;
  `}
`

export const TitleWrapper = styled.div`
  &:before {
    content: '';
    position: absolute;
    top: 17px;
    background-image: url(${cubes});
    background-repeat: no-repeat;
    z-index: 1;
    width: 339px;
    height: 64px;

    ${({ locale }) =>
      locale == 'en'
        ? css`
            transform: translateX(138px);
          `
        : css`
            transform: translateX(230px);
          `}

    ${media.lessThan('medium')`
      background-image: url(${mcubes});
      height: 40px;

      ${({ locale }) =>
        locale == 'en'
          ? css`
              width: 115px;
              transform: translateX(108px);
            `
          : css`
              width: 95px;
              transform: translateX(168px);
            `}
    `}
  }
`

export const Title = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.primary.main};
    font-family: ${theme.font.familyTertiary};
    font-size: ${theme.font.sizes.title};
    text-align: center;
    font-size: ${theme.font.sizes.xxlarge};
    font-weight: ${theme.font.bold};
    line-height: 56px;
    letter-spacing: 0em;
    text-align: right;

    ${media.lessThan('medium')`
      font-size: ${theme.font.sizes.xlarge};
    `}
  `}
`
